<script>
import { generateConfirm } from '@utils/feeline-confirm'

export default {
  props: {
    showModal: {
      type: Boolean,
      default: false,
      require: false,
    },
    type: {
      type: String,
      default: 'edit',
      require: false,
    },
  },
  computed: {
    confirmComputed() {
      return generateConfirm(this.type)
    },
  },
  methods: {
    closeModal() {
      this.$emit('close')
    },
    submit() {
      this.$emit('submit')
    },
  },
}
</script>

<template>
  <validation-observer ref="observer" v-slot="{ handleSubmit }">
    <CForm ref="form" @submit.stop.prevent="handleSubmit(submit)">
      <CModal :show="showModal" size="lg" centered>
        <slot name="form"></slot>
        <template v-slot:header>
          {{ confirmComputed.title || $t('confirm.editDevice.title') }}
        </template>
        <template v-slot:footer>
          <CButton color="danger" class="mb-2" type="submit">
            {{ confirmComputed.btn }}
          </CButton>
          <CButton color="light" class="mb-2" @click="closeModal">
            {{ confirmComputed.close_btn || $t('common.cancel') }}
          </CButton>
        </template>
      </CModal>
    </CForm>
  </validation-observer>
</template>
